<template>
  <div class="container-fluid">
    <slot name="modal"></slot>
    <div class="master-layout-container" style="background:#f2f3f5">
      <div class="main-content">
        <div class="header-container">
          <slot name="header"></slot>
        </div>
        <div class="notifications-container">
          <slot name="notifications" />
        </div>
        <div v-if="!showSidePanel">
          <div class="dashboard-container">
            <slot name="panel"></slot>
          </div>
        </div>
        <div v-else class="dashboard-flex-container">
          <div class="dashboard-container dashboard-mainpanel-container">
          <slot name="panel"></slot>
          </div>
          <div class="dashboard-sidepanel-container">
            <slot name="sidepanel"></slot>
          </div>
        </div>
      </div>
    </div>
    <transition-overlay-modal v-if="showTransitionModal"
      :fadeIn="transitionModalFadeIn"
      :fadeOut="transitionModalFadeOut"
    ></transition-overlay-modal>
  </div>
</template>

<script>
  import TransitionOverlayModal from '@/components/dashboard/modals/TransitionOverlayModal'
  export default {
    name: 'DashboardLayoutTemplate',
    components: {
      TransitionOverlayModal
    },
    props: {
      showTransitionModal: {
        type: Boolean,
        required: true
      },
      transitionModalFadeIn: {
        type: Boolean,
        required: true
      },
      transitionModalFadeOut: {
        type: Boolean,
        required: true
      },
      showSidePanel: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        sideNavType: 'Merchant'
      }
    }
  }
</script>

<style scoped lang='scss'>
@import '@/../assets/scss/shipbob-custom/components/dashboard/_setup-dashboard.scss';
// .main-content {
//   background-color: #f2f3f5
// }
</style>
